export default __webpack_public_path__ + "static/media/logo-dailycious.1dbe9e5f.svg";